import React, { useRef } from "react";
import styled from "styled-components";
import {
  HorizontalContainer,
  HorizontalMarginSmall,
  VerticalContainer,
  VerticalMargin,
} from "../Common";
import ReactToPrint from "react-to-print";
import { RaisedButton } from "material-ui";
import "./print-component.css";
import * as TimeUtils from "../../general/time-utils";

const Container = styled.div`
  padding-bottom: 10mm;
  padding-left: 10mm;
  padding-right: 10mm;
  page-break-inside: avoid;
`;

const FlexCenteredText = styled.span`
  flex: 1;
  text-align: center;
`;

const Table = styled.table`
  width: 100%;
  border: 1px solid black;
`;

const Tr = styled.tr`
  border: 1px solid black;
`;

const Td = styled.td`
  border: 1px solid black;
  padding-left: 8px;
  padding-right: 8px;
`;

const ThTitle = styled.th`
  border: 1px solid black;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
`;

const SignatureImage = styled.img`
  width: 200px;
  height: 100px;
  object-fit: contain;
`;

const SignatureContainer = styled(VerticalContainer)`
  flex: 1;
  align-items: center;
`;

const isApproved = (state) => {
  return state === 2;
};

const getApprovedNamesAndCallings = (paper) => {
  if (!paper) {
    return {};
  }

  const isPaperApproved = isApproved(paper.state);
  const dataMap = {};

  paper.flow.steps.forEach((s) => {
    paper.approvals.forEach((a) => {
      //if for that orderNumber there is an approval we use data from Appoval
      if (s.stepOrder === a.orderNumber) {
        const name = a.firstName + " " + a.lastName;
        dataMap[a.orderNumber] = {
          user: a.approvedBy,
          name,
          calling: a.calling,
        };
      }
    });

    if (!isPaperApproved) {
      //if there is not an approval for that orderNumber we use data from Flow
      if (!dataMap[s.stepOrder]) {
        const name = s.signedBy.firstName + " " + s.signedBy.lastName;
        dataMap[s.stepOrder] = { user: s.signedBy, name, calling: s.calling };
      }
    }
  });

  console.log("lucitest here", dataMap);
  return dataMap;
};

const renderHeader = (paper) => {
  return (
    <div>
      <strong>Opera Naţională Română Cluj-Napoca</strong>

      <HorizontalContainer>
        <span>Cod: {" " + paper.yearId + "/" + paper.createdYear}</span>
        <HorizontalMarginSmall />
        <strong>{isApproved(paper.state) ? "AA" : "NA"}</strong>
      </HorizontalContainer>

      <span>
        Data crearii:
        {" " + TimeUtils.getSimpleFormat(paper.createdDate)}
      </span>

      <VerticalMargin />
      <VerticalMargin />
    </div>
  );
};

const renderSignature = (link) => {
  return (
    <SignatureContainer>
      {link ? (
        <SignatureImage src={link} />
      ) : (
        <div style={{ backgroundColor: "red", height: 50 }} />
      )}
    </SignatureContainer>
  );
};

const STEP_1_ACHIZITII = "1";
const STEP_2_CFP = "2";
const STEP_3_ADJUNCT_MANAGER = "3";
const STEP_4_MANAGER = "4";

const renderFirstSignatures = (paper, approvedNamesAndCalling) => {
  const signatureManager =
    isApproved(paper.state) &&
    approvedNamesAndCalling[STEP_4_MANAGER]?.user?.signatureLink;

  const signatureAdjunctManager =
    isApproved(paper.state) &&
    approvedNamesAndCalling[STEP_3_ADJUNCT_MANAGER]?.user?.signatureLink;

  return (
    <VerticalContainer>
      <HorizontalContainer style={{ width: "100%" }}>
        <FlexCenteredText>
          {/* {approvedNamesAndCalling[STEP_4_MANAGER]?.calling} */}
          <div>Manager</div>
          <div>Bogdan Gheorghiu</div>
        </FlexCenteredText>
        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_3_ADJUNCT_MANAGER]?.calling}
        </FlexCenteredText>
      </HorizontalContainer>

      <HorizontalContainer style={{ width: "100%" }}>
        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_4_MANAGER]?.name}
        </FlexCenteredText>

        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_3_ADJUNCT_MANAGER]?.name}
        </FlexCenteredText>
      </HorizontalContainer>

      <HorizontalContainer>
        {renderSignature(signatureManager)}
        {renderSignature(signatureAdjunctManager)}
      </HorizontalContainer>
    </VerticalContainer>
  );
};

const renderTitleSection = (paper) => {
  return (
    <VerticalContainer>
      <FlexCenteredText>
        <strong>Proiect de angajament legal individual</strong>
      </FlexCenteredText>
      <FlexCenteredText>
        <strong>REFERAT DE NECESITATE</strong>
      </FlexCenteredText>
      <FlexCenteredText>
        <span>{paper.department.name}</span>
      </FlexCenteredText>

      <VerticalMargin />

      <HorizontalContainer>
        <span>
          <strong>Persoana de contact: </strong>{" "}
          {paper.createdBy.firstName + " " + paper.createdBy.lastName}
          {", "}
          <strong>e-mail</strong> {paper.createdBy.email}
        </span>
      </HorizontalContainer>

      <span>
        <strong>Categoria de achizitie:</strong>{" "}
        {paper.acquisitionCategory.name}
      </span>

      <span>
        <strong>Sursa de finantare:</strong> {paper.financeSource.name}
      </span>

      <span>
        <strong>Justificarea achizitiei:</strong> {paper.justification}
      </span>

      <VerticalMargin />

      <span>
        Va rugam sa ne aprobati procurarea urmatoarelor
        produse/servicii/lucrari:
      </span>
    </VerticalContainer>
  );
};

const renderTable = (p) => {
  let totalNoVat = 0;
  let totalWithVat = 0;
  return (
    <Table>
      <Tr>
        <ThTitle>
          <strong>Id articol</strong>
        </ThTitle>
        <ThTitle>
          <strong>Denumire</strong>
        </ThTitle>
        <ThTitle>
          <strong>U/M</strong>
        </ThTitle>
        <ThTitle>
          <strong>Cant</strong>
        </ThTitle>
        <ThTitle>
          <strong>Pret unitar estimat</strong>
        </ThTitle>
        <ThTitle>
          <strong>Valoare totala estimata</strong>
        </ThTitle>
        <ThTitle>
          <strong>Valoare totala estimata cu TVA</strong>
        </ThTitle>
        <ThTitle>
          <strong>Cod SSI</strong>
        </ThTitle>
      </Tr>

      {p.articles.map((a) => {
        const priceNoVat = a.quantity * a.pricePerUnit;
        const priceWithVat = (priceNoVat * a.vat) / 100 + priceNoVat;

        totalNoVat += priceNoVat;
        totalWithVat += priceWithVat;
        return (
          <Tr>
            <Td>{p.yearId + "/" + p.createdYear + "/" + a.orderId}</Td>
            <Td>
              <VerticalContainer>
                <div>{a.product.name}</div>
                <div>{a.details ? "Detalii: " + a.details : ""}</div>
              </VerticalContainer>
            </Td>
            <Td>{a.unitMeasure}</Td>
            <Td>{a.quantity}</Td>
            <Td>{a.pricePerUnit}</Td>
            <Td>{priceNoVat.toFixed(1)}</Td>
            <Td>{priceWithVat.toFixed(1)}</Td>
            <Td>{a.articolBugetar ? a.articolBugetar : ""}</Td>
          </Tr>
        );
      })}

      <Tr>
        <Td colSpan="5">Total</Td>
        <Td>{totalNoVat.toFixed(1)}</Td>
        <Td>{totalWithVat.toFixed(1)}</Td>
      </Tr>
    </Table>
  );
};

const renderSecondSignatures = (p, approvedNamesAndCalling) => {
  const signatureAchizitii =
    isApproved(p.state) &&
    approvedNamesAndCalling[STEP_1_ACHIZITII]?.user.signatureLink;
  const signatureCreatedBy = isApproved(p.state) && p.createdBy.signatureLink;

  const signatureCfp =
    isApproved(p.state) &&
    approvedNamesAndCalling[STEP_2_CFP]?.user?.signatureLink;

  return (
    <div className={"noBreak"}>
      <HorizontalContainer style={{ width: "100%" }}>
        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_1_ACHIZITII]?.calling}
        </FlexCenteredText>

        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_2_CFP]?.calling}
        </FlexCenteredText>
        <FlexCenteredText>INTOCMIT</FlexCenteredText>
      </HorizontalContainer>

      <HorizontalContainer style={{ width: "100%" }}>
        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_1_ACHIZITII]?.name}
        </FlexCenteredText>

        <FlexCenteredText>
          {approvedNamesAndCalling[STEP_2_CFP]?.name}
        </FlexCenteredText>
        <FlexCenteredText>
          {p.createdBy.firstName + " " + p.createdBy.lastName}
        </FlexCenteredText>
      </HorizontalContainer>

      <HorizontalContainer>
        {renderSignature(signatureAchizitii)}
        {renderSignature(signatureCfp)}
        {renderSignature(signatureCreatedBy)}
      </HorizontalContainer>
    </div>
  );
};
export const PrintComponent = ({ paper }) => {
  const approvedNamesAndCalling = getApprovedNamesAndCallings(paper);
  let componentRef = useRef();

  return (
    <div>
      <ReactToPrint
        bodyClass="patchPrintStyle"
        trigger={() => <RaisedButton primary>PRINT</RaisedButton>}
        content={() => componentRef}
        copyStyles={true}
        onBeforePrint={() => {
          console.log("paper", paper);
        }}
      />
      <Container ref={(el) => (componentRef = el)}>
        {renderHeader(paper)}
        {renderFirstSignatures(paper, approvedNamesAndCalling)}
        <VerticalMargin />
        {renderTitleSection(paper)}
        <VerticalMargin />
        {renderTable(paper)}
        <VerticalMargin />
        {renderSecondSignatures(paper, approvedNamesAndCalling)}
      </Container>
    </div>
  );
};
